export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15207.626d04f6.jpg";